import styled from 'styled-components';
import { BoxWrapper } from '../BoxWrapper';

export const Wrapper = styled(BoxWrapper)`
    margin-bottom: 0.5rem;
    flex-grow: 1;
`;

export const SubWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Text = styled.span`
    font-size: 1rem;
`;
